import { notification } from 'antd';
import { type NotificationInstance } from 'antd/lib/notification/interface';
import { createContext, type PropsWithChildren, useContext, useMemo } from 'react';

export type NotificationType = 'success' | 'info' | 'warning' | 'error';

interface NotificationConsumerProps {
	readonly notificationApi: NotificationInstance;
}

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Legacy code
const NotificationContext = createContext({} as NotificationConsumerProps);

export function NotificationProvider({ children }: PropsWithChildren) {
	const [api, contextHolder] = notification.useNotification({
		duration: 0,
		placement: 'top',
		maxCount: 1,
	});

	const notificationValue = useMemo<NotificationConsumerProps>(() => ({ notificationApi: api }), []);

	return (
		<NotificationContext.Provider value={notificationValue}>
			{contextHolder}
			{children}
		</NotificationContext.Provider>
	);
}

export const useNotificationApi = () => {
	return useContext(NotificationContext);
};
